"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerStandCommand = void 0;
const player_command_1 = require("./player-command");
const croupier_auto_deal_rule_1 = require("../../game-rules/croupier-auto-deal-rule");
const send_all_results_rule_1 = require("../../game-rules/send-all-results-rule");
const move_next_player_rule_1 = require("../../game-rules/move-next-player-rule");
const show_controls_rule_1 = require("../../game-rules/show-controls-rule");
const logic_types_1 = require("../../logic-types");
const reach_target_score_fork_rule_1 = require("../../game-rules/reach-target-score-fork-rule");
const common_rules_1 = require("./common-rules");
class PlayerStandCommand {
    static isCommand(command) {
        return command instanceof PlayerStandCommand;
    }
    serializeToString() {
        return player_command_1.CommandTypes.Stand;
    }
    validateCommand(context) {
        return context.gameState.isAllowed(logic_types_1.PlayerControls.Stand);
    }
    executeCommand(commandHash, existingDeal, instant, context) {
        return __awaiter(this, void 0, void 0, function* () {
            context.gameState.setRoundState(logic_types_1.RoundState.Transition, instant);
            const playerId = context.playerManager.getCurrentPlayerId();
            if (context.logicVersion <= 1) {
                yield this.resultRulesV1(context, playerId).execute(commandHash, existingDeal, instant, context);
            }
            else {
                yield this.resultRules(context, playerId).execute(commandHash, existingDeal, instant, context);
            }
        });
    }
    resultRules(context, playerId) {
        return common_rules_1.CommonRules.nextTurnOrEndRules(context, playerId);
    }
    //
    // Legacy
    //
    resultRulesV1(context, playerId) {
        const playerNextTurn = context.playerManager.playerNextTurn(playerId);
        if (playerNextTurn) {
            return this.nextPlayerRules(playerNextTurn);
        }
        return this.continueRules();
    }
    continueRules() {
        const croupierAutoDealRule = new croupier_auto_deal_rule_1.CroupierAutoDealRule();
        const sendAllResultsRule = new send_all_results_rule_1.SendAllResultsRule();
        croupierAutoDealRule.setNext(sendAllResultsRule);
        return croupierAutoDealRule;
    }
    nextPlayerRules(nextPlayer) {
        const showControlsRule = new show_controls_rule_1.ShowControlsRule();
        const reachTargetScoreForkRule = new reach_target_score_fork_rule_1.ReachTargetScoreForkRule(nextPlayer.playerId, showControlsRule, this.continueRules());
        const moveNextPlayerRules = new move_next_player_rule_1.MoveNextPlayerRule(nextPlayer.playerId);
        moveNextPlayerRules.setNext(reachTargetScoreForkRule);
        return moveNextPlayerRules;
    }
}
exports.PlayerStandCommand = PlayerStandCommand;
